module.exports = __webpack_public_path__ + "img/kleisma2.a2b4ea71.jpg";